export default {
  进入企业云展: 'Enter the CloudEnterprise',
  暂无相关的产业头条: 'No relevant industry news yet.',
  作者: 'Published by',
  分类: 'Category',
  发布时间: 'Published on',
  阅读数: 'Total Views',
  非原创: 'Unoriginal',
  转载于: 'Origin:',
  凡本网注明来源:
    '*This website holds the copyright to all works uploaded by Could Exhibition. Please credit this website as the source when reposting.',
  凡注明为其它来源的信息:
    '*All views expressed on the content published by our users don’t represent the opinions of this website. If anyone has infringed on your copyright, please contact us.',
  该头条已下架: 'Content removed.',
  该头条不存在: "Content doesn't exist.",
}
